module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/pod.ba954328.svg";